import { EditorComponent } from '@tinymce/tinymce-angular';

/**
 * TinyMCE is self-hosted (copied from node_modules to /tinymce by the build), so no text or usage goes to Tiny Cloud
 * and there is no editor-load limit. TinyMCE 8 is licensed under GPL v2+ or Tiny's commercial terms: "gpl" selects
 * the open-source licence – replace it with a commercial licence key if iSophi buys one.
 */
export const TINYMCE_LICENSE_KEY = 'gpl';
export const TINYMCE_SCRIPT = '/tinymce/tinymce.min.js';

/** Word-like editor for the Lodní deník texts (Třídnice activities, individual entries). */
export const richTextEditorInit: EditorComponent['init'] = {
  license_key: TINYMCE_LICENSE_KEY,
  base_url: '/tinymce',
  suffix: '.min',
  language: 'cs',
  language_url: '/tinymce/langs/cs.js',
  branding: false,
  promotion: false,
  elementpath: false,
  menubar: 'edit view insert format table',
  plugins: 'autoresize lists advlist table link charmap searchreplace wordcount fullscreen',
  toolbar:
    'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor | ' +
    'alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | table link | removeformat | fullscreen',
  toolbar_mode: 'wrap',
  block_formats: 'Odstavec=p; Nadpis 1=h2; Nadpis 2=h3; Nadpis 3=h4',
  font_size_formats: '10pt 11pt 12pt 14pt 16pt 18pt 24pt',
  // fonts as in Word (POR-001 image 9); the default is the app font
  font_family_formats:
    'Výchozí=Inter, Arial, sans-serif; Calibri=Calibri, Carlito, Arial, sans-serif; Arial=Arial, Helvetica, sans-serif; ' +
    'Times New Roman="Times New Roman", Times, serif; Georgia=Georgia, serif; Verdana=Verdana, Geneva, sans-serif; ' +
    'Comic Sans MS="Comic Sans MS", "Comic Sans", cursive',
  // no fixed height: the editor grows with its text
  min_height: 240,
  autoresize_bottom_margin: 24,
  // pasted images would be stored as huge base64 strings in the record; photos belong to Lodní deník entries
  paste_data_images: false,
  convert_urls: false,
  // store Czech characters as they are (the default would write &iacute; etc. into the records)
  entity_encoding: 'raw',
  link_default_target: '_blank',
  link_assume_external_targets: 'https',
  content_style: 'body { font-family: Inter, Arial, sans-serif; font-size: 11pt; } table { border-collapse: collapse; }',
};
